// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /member/list.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeMemberListBody,
  typeMemberListOutput200,
} from "../../sdk/member/postMemberList";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildMemberListQueryKey(payload: typeMemberListBody): string[] {
  const queryKeySegments: string[] = [];
  queryKeySegments.push(`poolId:${JSON.stringify(payload.poolId)}`);
  if (typeof payload.statuses !== "undefined") {
    queryKeySegments.push(`statuses:${JSON.stringify(payload.statuses)}`);
  }
  if (typeof payload.cursor !== "undefined") {
    queryKeySegments.push(`cursor:${JSON.stringify(payload.cursor)}`);
  }
  if (typeof payload.limit !== "undefined") {
    queryKeySegments.push(`limit:${JSON.stringify(payload.limit)}`);
  }
  return ["post:member:memberList", "svc:pool-api", ...queryKeySegments];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeMemberListOutput200,
    unknown,
    typeMemberListOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useMemberList(
  payload: typeMemberListBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildMemberListQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postMemberList(payload),
    ...resolvedOptions,
  });
}
